var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "relative",
        overflow: "auto",
        "max-height": "inherit"
      },
      style: {
        maxWidth: 15 * _vm.gridUnitSize + "px"
      }
    },
    [
      _c("table", { style: _vm.cssProps }, [
        _c("thead", [
          _c(
            "tr",
            [
              _c("th", { staticClass: "invisible" }),
              _vm._v(" "),
              _vm._l(_vm.numberOfColumns, function(column) {
                return _c("th", { key: column }, [
                  _vm._v("\n          " + _vm._s(column) + "\n        ")
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.gridUnits, function(row, rowIndex) {
            return _c(
              "tr",
              { key: rowIndex },
              [
                _c("th", [_vm._v(_vm._s(rowIndex + 1))]),
                _vm._v(" "),
                _vm._l(row, function(gridUnit) {
                  return _c(
                    "td",
                    {
                      key: gridUnit.rowIndex + gridUnit.columnIndex,
                      class: {
                        disabled: _vm.disabled,
                        occupied: _vm.gridUnitHasDuctEntry(gridUnit)
                      },
                      on: {
                        click: function($event) {
                          return _vm.onGridUnitClick(gridUnit)
                        }
                      }
                    },
                    [
                      _vm.gridUnitHasDuctEntry(gridUnit)
                        ? _c("grid-duct-entry", {
                            attrs: {
                              "duct-entry-index": _vm.getGridUnitDuctEntryIndex(
                                gridUnit
                              )
                            },
                            on: {
                              showContextMenu: function($event) {
                                return _vm.showContextMenu($event, gridUnit)
                              },
                              hideContextMenu: _vm.hideContextMenu
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                })
              ],
              2
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("duct-entry-menu", {
        attrs: {
          "show-menu": _vm.showMenu,
          x: _vm.menuX,
          y: _vm.menuY,
          "duct-entry-index": _vm.clickedDuctEntryIndex
        },
        on: { delete: _vm.deleteDuctEntry }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10baeaf9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10baeaf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskGrid.vue
// module id = null
// module chunks = 